import React from 'react';
import PropTypes from 'prop-types';
import { observer, inject } from 'mobx-react';

import { GroupsAppManager } from 'apps/group/appManager';
import { SectionTitle } from 'apps/group/styles';
import { routerStore } from 'core/routing';
import { clientStore } from 'apps/client/app';
import { Box, List, ListItem, Heading } from 'components';
import {
  Accordion,
  AccordionButton,
  AccordionIcon,
  AccordionItem,
  AccordionPanel,
} from '@chakra-ui/react';
import { Check } from 'icons';

import styled from 'styled-components';

import CollaboratorSettings from 'libs/rendering/components/header/collaboratorsSettings';

const rolePermissions = {
  // admin: [
  //   'Edit and manage project Overview and Settings.',
  //   'Invite and manage Project Admins, Editors and Viewers.',
  //   'Upload, replace and delete files in Drive.',
  //   'Edit and contribute changes to Readme documentation.',
  //   'Open, assign and close Tasks.',
  //   'Create Task Labels.',
  //   'Comment in CAD, History Contributions, and Tasks.',
  //   'Submit RFQs and manage Orders with Project Files.',
  // ],
  // editor
  collaborator: [
    'Upload, replace and delete files in Drive.',
    'Edit and contribute changes to Readme documentation.',
    'Open and Assign Tasks.',
    'Comment in CAD, History Contributions, and Tasks.',
  ],
  // Viewer
  'limited-collaborator': [
    'View files in Drive.',
    'Open Tasks.',
    'Comment in CAD files, History Contributions, and Tasks.',
  ],
};

@inject('routerStore')
@observer
export class TeamSettings extends React.Component {
  UNSAFE_componentWillMount() {
    this.groupsManager = new GroupsAppManager(null, this.props);
    this.projectManager = this.props.projectManager;
  }

  componentDidMount() {
    const { initiative, profile } = routerStore.route.params;

    if (initiative) {
      this.groupsManager.InitiativeQuery(initiative);
      this.groupsManager.QueryTeamGroup(initiative);
    } else {
      this.groupsManager.ProfileQuery(profile);
    }
  }

  render() {
    const permissionsComponents = [];

    if (!clientStore.activeSpace) return null;

    Object.keys(rolePermissions).forEach(key => {
      let displayName = '';
      if (key === 'admin') {
        displayName = 'Project Admins';
      } else if (key === 'collaborator') {
        displayName = 'Editors';
      } else if (key === 'limited-collaborator') {
        displayName = 'Viewers';
      }
      const entries = rolePermissions[key];
      permissionsComponents.push(
        <React.Fragment key={key}>
          <StyledPermissionsAccordion allowToggle defaultIndex={[0]}>
            <AccordionItem style={{ border: 'none' }}>
              <AccordionButton
                style={{
                  paddingBottom: '0px',
                  marginBottom: '0px',
                }}
              >
                <SectionTitle level={2} size='small'>
                  {`${displayName} permissions`}
                </SectionTitle>
                <StyledAccordionIcon />
              </AccordionButton>
              <AccordionPanel>
                <List
                  icon={<Check />}
                  style={{
                    paddingVertical: '0px',
                    marginVertical: '0px',
                  }}
                >
                  {entries
                    ? entries.map((row, i) => {
                        return (
                          <ListItem
                            key={i}
                            style={{
                              marginBottom: '0px',
                              marginTop: '0px',
                            }}
                          >
                            {row}
                          </ListItem>
                        );
                      })
                    : null}
                </List>
              </AccordionPanel>
            </AccordionItem>
          </StyledPermissionsAccordion>
          <Box
            style={{
              margin: '1em 0',
              height: '1px',
              backgroundColor: '#d8d8d8',
            }}
          />
        </React.Fragment>,
      );
    });

    const { initiative, profile } = routerStore.route.params;

    return (
      <div className='flex flex-col screen1160:items-center'>
        <div className='w-1/2'>
          <CollaboratorSettings
            manager={this.groupsManager}
            isProject={true}
            borderless={true}
            getRepeatUsers={() => {
              // temp fix
              return true;
              // return this.groupsManager.getRepeatInvitationUsers(invitedUsers);
            }}
            dataTestId='projectPage-settingLink-section'
            spaceSlug={initiative || profile}
            projectManager={this.projectManager}
          />
          <div className='pl-4' style={{ width: '38rem' }}>
            <Heading
              level={2}
              size='medium'
              style={{ marginLeft: '1rem', marginTop: '2em' }}
            >
              Project Permission Description
            </Heading>
            {permissionsComponents}
          </div>
        </div>
      </div>
    );
  }
}

TeamSettings.propTypes = {
  projectManager: PropTypes.object,
  groupsManager: PropTypes.object,
};

const StyledPermissionsAccordion = styled(Accordion)`
  border: none;
  ul {
    padding-left: 0em;
  }
`;

const StyledAccordionIcon = styled(AccordionIcon)`
  margin-left: 0.5em;
  margin-top: -0.7em;
`;
